// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XKUt48PLCKv4VGYKrflE,.theBtk_gG002wB8AiPaf{display:flex;font-size:56px;line-height:56px;font-weight:bold;margin:0;order:0;padding:0;width:60%}.XKUt48PLCKv4VGYKrflE i,.theBtk_gG002wB8AiPaf i{font-size:45px;line-height:56px}.NSa15tP_78Tb9yHFva9W,.En0i_y2QU97Hcq_hk8Qh{color:#4ee4b3}@media screen and (max-width: 767px){.XKUt48PLCKv4VGYKrflE,.theBtk_gG002wB8AiPaf{font-size:24px;line-height:24px}.XKUt48PLCKv4VGYKrflE i,.theBtk_gG002wB8AiPaf i{font-size:22px;line-height:22px}}@media screen and (max-width: 480px){.theBtk_gG002wB8AiPaf{line-height:32px}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scheduleTitle": `XKUt48PLCKv4VGYKrflE`,
	"scheduleTitle": `theBtk_gG002wB8AiPaf`,
	"scheduleTitleIcon": `NSa15tP_78Tb9yHFva9W`,
	"scheduleTitleIcon": `En0i_y2QU97Hcq_hk8Qh`
};
module.exports = ___CSS_LOADER_EXPORT___;
